// @flow
import styled from "styled-components"
import { Text } from "componentsStyled/Typography"

export const Circle = styled.div`
  display: flex;
  flex-shrink: 0;
  border-radius: 10rem;
  width: 1rem;
  height: 1rem;
  margin-right: 1rem;
  border: 0.2rem solid ${(props) => props.theme.color.primaryAccent};
  color: ${(props) => props.theme.color.white};
`;

export const StyledText = styled(Text)`
  font-weight: ${(props) => props.theme.fontWeights.book};
  color: ${(props) => props.theme.color.primaryText};
  margin: 0;
  line-height: ${p => p.minimal 
  ? `2.5rem`
  : `4rem`};
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: baseline;
  width: 80%;
  margin-bottom: 1rem;
`



// WEBPACK FOOTER //
// ./src/components/Bulletpoint/styled.js